import { Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

export const IconBottomNavigationHome = (props: IconProps) => {
  const { size = 18, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      color={color ?? 'black'}
      {...otherProps}
    >
      <Path
        d="M3 16V6.6773L9 2L15 6.6773V16H10.523V10.4542H7.477V16H3Z"
        fill="currentColor"
      />
    </Svg>
  );
};

export const IconBottomNavigationOrder = (props: IconProps) => {
  const { size = 18, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      color={color ?? 'black'}
      {...otherProps}
    >
      <Path
        d="M17.6476 11H0.370549C0.14301 11 -0.0466797 11.2705 0.0101812 11.541C0.294601 12.9427 1.37566 14 2.64631 14H15.3528C16.6424 14 17.7045 12.9427 17.9889 11.541C18.046 11.2705 17.8752 11 17.6476 11H17.6476Z"
        fill="currentColor"
      />
      <Path
        d="M17.2667 8.86719H0.400966C0.158924 8.86719 0.00997251 9.08697 0.0845179 9.28978C0.345129 9.91519 1.08969 10.2871 1.83442 10.0843C2.07646 10.0167 2.31839 9.89831 2.52316 9.72922C3.2119 9.13753 4.34745 9.13753 5.05488 9.72922C5.74362 10.3209 6.87917 10.3209 7.5866 9.72922C8.27534 9.13753 9.41089 9.13753 10.1183 9.72922C10.8071 10.3209 11.9426 10.3209 12.65 9.72922C13.3388 9.13753 14.4743 9.13753 15.1818 9.72922C15.3865 9.8983 15.6099 10.0166 15.8705 10.0843C16.615 10.304 17.3783 9.89831 17.6204 9.27291C17.6577 9.06998 17.49 8.86719 17.2667 8.86719H17.2667Z"
        fill="currentColor"
      />
      <Path
        d="M0.322519 7.99999H17.6962C17.924 7.99999 18 7.76359 18 7.52707C18 6.2266 16.7659 5.33997 14.9619 4.76864C14.5442 5.24156 14.2214 5.79326 13.9745 6.40404C13.9365 5.85233 13.9935 5.28086 14.1645 4.72916C14.1834 4.67006 14.2025 4.61096 14.2214 4.57151C13.0632 4.29567 11.7341 4.11836 10.3859 4.03948C9.60739 4.63062 8.99986 5.43851 8.62014 6.40388C8.58213 5.85218 8.63908 5.2807 8.81007 4.729C8.88596 4.47281 9 4.23641 9.1139 4H8.99999C7.51896 4 5.99996 4.1182 4.65184 4.3744C4.06325 4.92611 3.58856 5.61577 3.26578 6.40388C3.22776 5.85218 3.28471 5.2807 3.45571 4.729C3.47465 4.68955 3.47465 4.6699 3.49372 4.63045C1.46198 5.18215 6.8924e-07 6.10822 6.8924e-07 7.52689C-0.000264188 7.78322 0.075761 7.99995 0.322508 7.99995L0.322519 7.99999Z"
        fill="currentColor"
      />
    </Svg>
  );
};

export const IconBottomNavigationRewards = (props: IconProps) => {
  const { size = 18, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      color={color ?? 'black'}
      {...otherProps}
    >
      <Path
        d="M9.94024 15.8567C12.1468 15.4061 15 13.7869 15 9.60058C15 5.79146 12.2661 3.25444 10.3002 2.08888C9.86329 1.82971 9.35294 2.17024 9.35294 2.68498V4.00101C9.35294 5.03914 8.92518 6.93398 7.73647 7.7223C7.12941 8.12474 6.47294 7.52216 6.39953 6.78784L6.33882 6.18454C6.26824 5.48333 5.568 5.05786 5.01882 5.48549C4.03129 6.25221 3 7.59847 3 9.59986C3 14.7193 6.73341 16 8.59976 16C8.70894 16 8.82282 15.9964 8.94141 15.9892C8.01953 15.9093 6.52941 15.3261 6.52941 13.4399C6.52941 11.9641 7.58471 10.967 8.38659 10.4811C8.60259 10.3515 8.85459 10.5206 8.85459 10.7762V11.201C8.85459 11.5249 8.97812 12.0325 9.27106 12.3795C9.60282 12.7726 10.0892 12.3608 10.128 11.8439C10.1407 11.6812 10.3016 11.5775 10.44 11.6596C10.8925 11.9295 11.4706 12.5055 11.4706 13.4399C11.4706 14.9144 10.6736 15.5925 9.94024 15.8567Z"
        fill="currentColor"
      />
    </Svg>
  );
};

export const IconBottomNavigationReorder = (props: IconProps) => {
  const { size = 18, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      color={color ?? 'black'}
      {...otherProps}
    >
      <Path
        d="M13.2364 4.7625C12.1482 3.675 10.6548 3 8.99625 3C5.67917 3 3 5.685 3 9C3 12.315 5.67917 15 8.99625 15C11.7955 15 14.1295 13.0875 14.7974 10.5H13.2364C12.621 12.2475 10.955 13.5 8.99625 13.5C6.5122 13.5 4.49343 11.4825 4.49343 9C4.49343 6.5175 6.5122 4.5 8.99625 4.5C10.242 4.5 11.3527 5.0175 12.1632 5.835L9.74672 8.25H15V3L13.2364 4.7625Z"
        fill="currentColor"
      />
    </Svg>
  );
};
